import { isMobileApp } from '@mightybyte/rnw.utils.device-info';
import { NativeModules } from 'react-native';

const appFlavor = (
    isMobileApp ? NativeModules.RNConfig.flavor : process.env.flavor
) as 'dev' | 'staging' | 'prod' | undefined;

if (
    !appFlavor ||
    (appFlavor !== 'prod' && appFlavor !== 'staging' && appFlavor !== 'dev')
) {
    throw 'Error: Invalid flavor specified. Must be "dev", "staging", or "prod"';
}

const serverURLs: { dev: string; staging: string; prod: string } = {
    dev: 'http://127.0.0.1:3000',
    staging: 'https://api.staging.sapphicsavvy.mightybyte.us',
    prod: 'https://api.sapphicsavvy.com',
};

const websiteBaseUrls: { dev: string; staging: string; prod: string } = {
    dev: 'http://localhost:8044',
    staging: 'https://sapphicsavvy.mightybyte.us/',
    prod: 'https://admin.sapphicsavvy.com',
};

const quarterDurationHours: { dev: number; staging: number; prod: number } = {
    dev: 24,
    staging: 168,
    prod: 168,
};

const talkJsAppId: { dev: string; staging: string; prod: string } = {
    dev: 'tioKIpoW',
    staging: 'tioKIpoW',
    prod: 'QyfpJJB8',
};

const envs = {
    FLAVOR: appFlavor,
    SERVER_URL: serverURLs[appFlavor],
    WEBSITE_BASE_URL: websiteBaseUrls[appFlavor],
    FORUM_URL: 'https://sapphicsavvy.discussion.community',
    LOCATION_PICKER_API: 'AIzaSyDiJaN3GQj6956Rqp9J4yA6J3sn46x0rJ4',
    QUARTER_DURATION_HOURS: quarterDurationHours[appFlavor],
    LINKS: {
        support: 'https://www.sapphicsavvy.com/articles/support',
        synthesis: 'https://www.sapphicsavvy.com/synthesis/synthesis',
        help: 'https://www.sapphicsavvy.com/help',
    },
    TALKJS_APP_ID: talkJsAppId[appFlavor],
    IS_CHAT_ENABLED: true,
};

export { envs };
